/**
 * Simplified version of:
 * https://github.com/fullstackreact/google-maps-react/blob/master/src/GoogleApiComponent.js
 */
import React, { Component, createRef } from 'react'
import { Loader } from 'src/components/Loader'
import { getKioskWindow } from 'src/utils/helpers'
import { ScriptCache } from './ScriptCache'

// TODO: PAT-2318 Remove if not needed
// const serialize = obj => JSON.stringify(obj);
// const isSame = (obj1, obj2) => obj1 === obj2 || serialize(obj1) === serialize(obj2);

export const GoogleMapApiWrapper = settings => WrappedComponent => {
  class GoogleMapApiWrapperComponent extends Component {
    constructor(props, context) {
      super(props, context)

      // Build options from input settings
      const options = typeof settings === 'function' ? settings(props) : settings

      // Initialize required Google scripts and other configured options
      this.initialize(options)

      this.state = {
        loaded: false,
        google: null,
      }

      this.googleMapRef = createRef()
    }

    // TODO: PAT-2318 Remove if not needed
    // UNSAFE_componentWillReceiveProps(props) {
    //   // Do not update input if it's not dynamic
    //   if (typeof settings !== 'function') {
    //     return;
    //   }
    //
    //   // Get options to compare
    //   const prevOptions = this.state.options;
    //   const options = typeof settings === 'function' ? settings(props) : settings;
    //
    //   // Ignore when options are not changed
    //   if (isSame(options, prevOptions)) {
    //     return;
    //   }
    //
    //   // Initialize with new options
    //   this.initialize(options);
    //
    //   // Save new options in component state,
    //   // and remove information about previous API handlers
    //   this.setState({
    //     options: options,
    //     loaded: false,
    //     google: null
    //   });
    // }

    componentWillUnmount() {
      if (this.unregisterLoadHandler) {
        this.unregisterLoadHandler()
      }
    }

    initialize(options) {
      // Avoid race condition: remove previous 'load' listener
      if (this.unregisterLoadHandler) {
        this.unregisterLoadHandler()
        this.unregisterLoadHandler = null
      }

      // Load cache factory
      const createCache = () => {
        return ScriptCache({
          googleApi: `https://maps.googleapis.com/maps/api/js?v=3.43&key=${options.googleApiKey}&libraries=places`,
        })
      }

      // Build script
      this.scriptCache = createCache()
      this.unregisterLoadHandler = this.scriptCache.googleApi.onLoad(this.onLoad.bind(this))
    }

    onLoad() {
      const getWindow = getKioskWindow()

      this.setState({
        loaded: true,
        google: getWindow.google,
      })
    }

    render() {
      const { loaded } = this.state

      if (!loaded) {
        return <Loader styleVariation='staticWithHeight' />
      }

      const getWindow = getKioskWindow()

      const props = Object.assign({}, this.props, {
        loaded: loaded,
        google: getWindow.google,
      })

      return (
        <div>
          <WrappedComponent {...props} />
          <div ref={this.googleMapRef} />
        </div>
      )
    }
  }

  return GoogleMapApiWrapperComponent
}

export default GoogleMapApiWrapper
